import { sql } from "drizzle-orm";
import { boolean, index, pgTable, text, uuid } from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import z from "zod";

import { customTimestamp } from "./utils/types";

export const adminsTable = pgTable(
  "admins",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    firstName: text("first_name").notNull(),
    lastName: text("last_name").notNull(),
    email: text("email").notNull().unique(),
    isSuperAdmin: boolean("is_super_admin").notNull().default(false),
    createdAt: customTimestamp("created_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString()),
    updatedAt: customTimestamp("updated_at")
      .notNull()
      .$defaultFn(() => new Date().toISOString())
      .$onUpdateFn(() => new Date().toISOString()),
  },
  table => [
    index("admins_first_name_trigram_idx").using(
      "gin",
      sql`${table.firstName} gin_trgm_ops`,
    ),
    index("admins_last_name_trigram_idx").using(
      "gin",
      sql`${table.lastName} gin_trgm_ops`,
    ),
    index("admins_email_trigram_idx").using(
      "gin",
      sql`${table.email} gin_trgm_ops`,
    ),
  ],
);

export const adminSchema = createSelectSchema(adminsTable, {
  email: z.email(),
});
export type AdminType = z.infer<typeof adminSchema>;

export const adminInsertSchema = createInsertSchema(adminsTable, {
  firstName: schema => schema.trim().min(1),
  lastName: schema => schema.trim().min(1),
  email: z.email(),
}).omit({
  createdAt: true,
  updatedAt: true,
});
export type AdminInsertType = z.infer<typeof adminInsertSchema>;

export const adminsOrderFieldSchema = z.enum([
  "FIRST_NAME",
  "LAST_NAME",
  "EMAIL",
]);
export type AdminsOrderFieldType = z.infer<typeof adminsOrderFieldSchema>;

export type AdminCursorType = {
  firstName: string;
  lastName: string;
  email: string;
};
